import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveCategories,
  findCategoriesByTitle,
  deleteAllCategories,
} from "../actions/categories";
import { Link } from "react-router-dom";

class CategoriesList extends Component {

  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveCategorie = this.setActiveCategorie.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllCategories = this.removeAllCategories.bind(this);

    this.state = {
      currentCategorie: null,
      currentIndex: -1,
      searchNom: "",
    };
  }


  componentDidMount() {
    this.props.retrieveCategories();


  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentCategorie: null,
      currentIndex: -1,
    });
  }

  setActiveCategorie(categorie, index) {
    this.setState({
      currentCategorie: categorie,
      currentIndex: index,
    });
  }

  removeAllCategories() {
    this.props
      .deleteAllCategories()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findCategoriesByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentCategorie, currentIndex } = this.state;
    const { categories } = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher une catégorie"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des catégories</h4>

          <ul className="list-group">

            {categories &&
              categories.map((categorie, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveCategorie(categorie)}
                  key={categorie.id}

                >
                    <ul> {categorie.Nom}
                    </ul>
                    <ul><img className="img" src={categorie.Img1} alt={categorie.Img1}/></ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllCategories}
          >
            Supprimer toutes les catégories
          </button>
        </div>
        <div className="col-md-6">
          {currentCategorie ? (
            <div>
              <h4>Categorie</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentCategorie.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentCategorie.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/categories/" + currentCategorie.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur une catégorie ou  </p>
              <p>  <a className="nav-item"
                            href="https://gestion.attirail.fr/addcategories" type="button"> Ajouter une catégorie </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.categories,
  };
};

export default connect(mapStateToProps, {
  retrieveCategories,
  findCategoriesByTitle,
  deleteAllCategories,
})(CategoriesList);
